import { createElement } from "react";
import { SOURCE_STATUS } from "../../../features/builder.constants";
import PayloadKeysEditor from "../domain-event-form/PayloadKeysEditor";
import SourceNotice from "../domain-event-form/SourceNotice";
import { extraPayload, sourceNotes, sourceOf } from "./domain-event.utils";

// EntityFormModal fields of a domain event.
export const domainEventFields = [
  {
    name: "event_key",
    label: "Event key",
    required: true,
    maxLength: 100,
    hint: "module.happening in lowercase, e.g. project.status_changed. Locked while a trigger uses the event.",
  },
  { name: "name", label: "Name", required: true, maxLength: 100 },
  {
    name: "source_fid",
    label: "Source",
    type: "select",
    is_api_data: true,
    optionsKey: "sources",
    optionLabelFormatter: (source) => `${source.label} (${source.source_key}) · ${SOURCE_STATUS[source.status]?.label ?? source.status}`,
    required: true,
  },
  { name: "sort_order", label: "Sort order", type: "number", min: 0, max: 10000 },
  {
    name: "source_notice",
    type: "custom",
    fullWidth: true,
    hidden: (formData, dependencies) => !sourceNotes(sourceOf(formData, dependencies)).length,
    render: ({ formData, dependencies }) => createElement(SourceNotice, { source: sourceOf(formData, dependencies) }),
  },
  { name: "is_activated", label: "Active", type: "boolean", defaultValue: true, editValue: (record) => record.is_activated === true },
  { name: "description", label: "Description", type: "textarea", fullWidth: true, rows: 2, maxLength: 500 },
  {
    name: "payload_schema",
    label: "Payload keys",
    type: "custom",
    fullWidth: true,
    hint: "What each emit(event_key, payload) sends. The locked keys are always included.",
    editValue: (record) => extraPayload(record.payload_schema).map(({ key, label, data_type }) => ({ key, label: label === key ? "" : label ?? "", data_type: data_type ?? "TEXT" })),
    render: ({ value, onChange, hasError }) => createElement(PayloadKeysEditor, { value, onChange, hasError }),
  },
];
